import { useState } from 'react'

const CURRENT_YEAR = new Date().getFullYear()
const YEARS = Array.from({ length: CURRENT_YEAR - 1900 + 1 }, (_, i) => CURRENT_YEAR - i)

const inputCls = 'border border-gray-300 rounded px-2 py-0.5 text-sm text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-400 w-20'

function YearCombo({ id, value, onChange }) {
  const [draft, setDraft] = useState(null)

  function commit(raw) {
    const n = parseInt(raw, 10)
    if (!isNaN(n) && n >= 1900 && n <= CURRENT_YEAR) onChange(n)
    setDraft(null)
  }

  return (
    <>
      <datalist id={id}>
        {YEARS.map(y => <option key={y} value={y} />)}
      </datalist>
      <input
        list={id}
        className={inputCls}
        value={draft ?? value}
        onChange={e => setDraft(e.target.value)}
        onBlur={e => commit(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') e.target.blur() }}
      />
    </>
  )
}

export function YearRangePicker({ yearFrom, yearTo, onYearFromChange, onYearToChange }) {
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-gray-500 text-xs">Od:</span>
      <YearCombo id="yr-from" value={yearFrom} onChange={onYearFromChange} />
      <span className="text-gray-400">—</span>
      <span className="text-gray-500 text-xs">Do:</span>
      <YearCombo id="yr-to" value={yearTo} onChange={onYearToChange} />
    </div>
  )
}
